import _ from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { Segment } from 'semantic-ui-react'
import { getFirstObject } from '../common/convert'
import { ParentContext } from '../cnr/contexts/ParentContext'
import { pickAll } from '../common/filtering'
import FullPageWrapper from '../wrappers/FullPageWrapper'
import UiSearchFilter from '../pageItem/UiSearchFilter'
import Wrapper, { wrapperTypes } from '../wrappers/Wrapper'
import { FrameworkContext } from 'global/cnr/contexts/FrameworkContent'
import { formatItem, formatTypes } from 'global/common/dateFormatting'

const WAIT_INTERVAL = 500;

const SearchPage = (props) => {

  const { handleShowSearch, item_state, data_state } = props ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { eventInfo_state } = states
  const { navigation_fns } = fns

  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { fw_info } = framework_state ?? {}
  const { view } = fw_info ?? {}


  const { appDataDocuments } = eventInfo_state ?? {}
  const appDataDocument = appDataDocuments?.[view]

  const { viewListData: vld } = data_state ?? {}
  const { viewItem } = item_state ?? {}
  const { key: key_viewItem } = viewItem ?? {}

  const [searchValue, updateSearchValue] = useState()
  const [foundItems, setFoundItems] = useState(key_viewItem && vld ? { [key_viewItem]: { vld } } : null)

  // const handleOk = () => {    console.log('Searching...')  }

  const triggerChange = (value) => {
    const _allMatches = {}
    if (appDataDocument) {
      const x = pickAll(value, appDataDocument, ['name', 'lastName', 'firstName'])
      if (x && x.length > 0) {
        _allMatches[view] = x
      }
    }
    setFoundItems(_allMatches)
  }

  const triggerChange_full = (value) => {
    const _allMatches = {}
    if (key_viewItem && vld) {
      const x = pickAll(value, vld, ['name', 'lastName', 'firstName'])
      if (x && x.length > 0) {
        _allMatches[key_viewItem] = x
      }
    } else {
      if (appDataDocuments) {
        Object.keys(appDataDocuments).forEach(key => {
          const sv = appDataDocuments[key]
          const x = pickAll(value, sv, ['name', 'lastName', 'firstName'])
          if (x && x.length > 0) {
            _allMatches[key] = x
          }
        })
      }
    }
    setFoundItems(_allMatches)
  }

  const handleClick = (key, itemKey) => {
    handleShowSearch && handleShowSearch()
    console.log('key, itemKey', key, itemKey)
    navigation_fns.handleNav_item({ key: key }, itemKey)

  }
  const handleSearchChange = (value) => { updateSearchValue(value) }
  const searchHeader = () => <div className={'search-page'}><UiSearchFilter handleSearchChange={handleSearchChange} /></div>

  useEffect(() => {
    if (searchValue) {
      const timer = setTimeout(() => triggerChange(searchValue), WAIT_INTERVAL);
      return () => clearTimeout(timer);
    }
    // eslint-disable-next-line
  }, [searchValue]);

  const resultList = (key, items) => {
    const _sty = { fontSize: '.9rem', padding: '1em', borderRadius: '4px', border: '1px solid var(--off-black-3' }
    const _items = _.sortBy(items, ['name', 'lastName', 'firstName', 'startDate', 'startTime'])
    const lis = _items.map(item => {
      const { firstName, lastName, name, startDate, startTime, _itemKey: itemKey } = item
      if (firstName && lastName) {
        return <div style={_sty} onClick={(e) => { handleClick(key, itemKey) }}>
          {firstName}{' '}{lastName}
        </div>
      } else {
        if (startDate && startTime) {
          return <div style={_sty} onClick={(e) => { handleClick(key, itemKey) }}>
            <div>{name}</div>
            <div style={{ marginTop: '.25em', color: 'var(--off-white-3)' }}>{`${formatItem(formatTypes.fullDate, startDate)} @ ${startTime}`}</div>
          </div >
        } else {
          return <div style={_sty} onClick={(e) => { handleClick(key, itemKey) }}>{name}</div>
        }

      }
    })
    return <div style={{ display: 'flex', gap: '.25em', flexDirection: 'column' }}>
      {lis.length > 0 ? lis : 'No items found'}
    </div>
  }

  const resultSeg = (key, items) => {
    if (vld) {
      return <Segment basic>{resultList(key, items)}</Segment>
    } else {
      return <Segment.Group>
        <Segment>{_.startCase(key)}</Segment>
        <Segment basic>{resultList(key, items)}</Segment>
      </Segment.Group>
    }
  }

  const searchResults = () => Object.keys(foundItems).map(key => {
    const item = foundItems[key]
    const { item: _item } = getFirstObject(item)
    return resultSeg(key, _item)
  })

  const content = () => <Wrapper
    header={searchHeader()}
    content={foundItems ? searchResults() : <div></div>}
    wrapperType={wrapperTypes.paddedFooter}
  />

  const searchWizard = () => <FullPageWrapper
    content={content()}
    handleCancel={handleShowSearch}
    topperCaption={`Search ${_.startCase(view)}`}
    css={{ container: 'app-dark-mode' }}
  />

  return searchWizard()
}

export default SearchPage